import { ActionType, AddTag } from "@redotech/redo-model/return-flow/action";
import * as React from "react";
import { ActionTypeSetup, RuleTypeDetailsProps } from "./multiple-actions";

export type AddTagState = string[];

export const ADD_TAG = (
  Details: React.ComponentType<RuleTypeDetailsProps<AddTagState>>,
): ActionTypeSetup<AddTagState, AddTag> => ({
  name: "Apply tags",
  description() {
    return "Adds tags to the ticket";
  },
  Details(props: RuleTypeDetailsProps<AddTagState>) {
    return React.createElement(Details, props);
  },
  empty: [],
  fromModel(model) {
    return typeof model.tag === "string" ? [model.tag] : model.tag;
  },
  toModel(state) {
    return { type: ActionType.AddTag, tag: state };
  },
  valid(state) {
    return true;
  },
});
